var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
import React from 'react';
import { createMuiTheme } from '@material-ui/core/styles';
import { ChevronRight, ChevronDown } from '@abdt/icons';
import { borderRadius, borderWidth, breakpoints, colors, fontWeight, palette, shadows, spacings, typography, zIndex, } from '@abdt/design-tokens';
import '../../index';
import '../../Message';
var theme = createMuiTheme({
    palette: {
        primary: {
            light: palette.primary.light,
            main: palette.primary.main,
            dark: palette.primary.dark,
            contrastText: colors.white,
        },
        secondary: {
            light: palette.secondary.light,
            main: palette.secondary.main,
            dark: palette.secondary.dark,
            contrastText: colors.white,
        },
        text: {
            primary: palette.text.primary,
            secondary: palette.text.secondary,
            disabled: palette.text.disabled,
        },
        error: {
            main: palette.error.main,
        },
        success: {
            main: palette.success.main,
        },
        warning: {
            main: palette.warning.main,
        },
        background: {
            default: '#ffffff',
        },
        grey: {
            50: colors.gray50,
            100: colors.gray100,
            200: colors.gray200,
            300: colors.gray300,
            400: colors.gray400,
            500: colors.gray500,
            600: colors.gray600,
            700: colors.gray700,
            800: colors.gray800,
            900: colors.gray900,
        },
        divider: palette.divider,
    },
    zIndex: {
        tooltip: zIndex.tooltip,
        modal: zIndex.modal,
        snackbar: zIndex.snackbar,
    },
    // 0, 4, 8, 16, 24, 32, 64
    spacing: __spreadArrays([
        0
    ], Object.values(spacings), [128, 128, 128, 128, 128]),
    shape: {
        borderRadius: borderRadius.s,
    },
    typography: {
        fontWeightLight: fontWeight.light,
        fontWeightRegular: fontWeight.regular,
        fontWeightMedium: fontWeight.medium,
        fontWeightBold: fontWeight.bold,
        h1: __assign({}, typography.headings.xxl),
        h2: __assign({}, typography.headings.xl),
        h3: __assign({}, typography.headings.l),
        h4: __assign({}, typography.headings.m),
        h5: __assign({}, typography.headings.s),
        h6: __assign({}, typography.headings.xs),
        body1: __assign({}, typography.text.xl),
        body2: __assign({}, typography.text.l),
        caption: __assign({}, typography.text.s),
        button: __assign({}, typography.text.l),
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: breakpoints.s,
            md: breakpoints.m,
            lg: breakpoints.l,
        },
    },
    Message: {
        root: {
            width: 400,
        },
    },
    DocViewer: {
        root: {
            display: 'flex',
            alignItems: 'center',
        },
    },
});
theme.props = {
    Well: {
        color: colors.neonGray50,
        boxProps: {
            borderRadius: borderRadius.s,
        },
    },
    Message: {
        variant: 'default',
    },
    MuiChip: {
        color: 'primary',
    },
    MuiContainer: {
        maxWidth: 'lg',
    },
    MuiAccordionSummary: {
        IconButtonProps: {
            disableRipple: true,
            disableTouchRipple: true,
            disableFocusRipple: true,
            edge: 'start',
        },
    },
    MuiTypography: {
        color: 'primary',
        variantMapping: {
            h1: 'h1',
            h2: 'h2',
            h3: 'h3',
            h4: 'h4',
            h5: 'h5',
            h6: 'h6',
            body1: 'p',
            body2: 'p',
            caption: 'span',
            subtitle1: 'p',
            subtitle2: 'p',
        },
    },
    MuiCircularProgress: {
        thickness: 2,
        size: 40,
    },
    MuiBreadcrumbs: {
        separator: React.createElement(ChevronRight, {
            color: theme.palette.grey[300],
        }),
    },
    MuiMenu: {
        elevation: 1,
    },
    MuiFormControl: {
        variant: 'outlined',
    },
    MuiSelect: {
        IconComponent: ChevronDown,
        variant: 'outlined',
    },
    MuiTextField: {
        variant: 'outlined',
    },
    MuiCheckbox: {
        disableRipple: true,
        color: 'primary',
    },
    MuiRadio: {
        disableRipple: true,
        color: 'primary',
    },
    MuiInputBase: {
        rows: 3,
    },
    MuiTabs: {
        indicatorColor: 'primary',
    },
    MuiTab: {
        textColor: 'secondary',
        disableRipple: true,
    },
    MuiButton: {
        disableFocusRipple: true,
        disableRipple: true,
        disableElevation: true,
        variant: 'contained',
        color: 'primary',
    },
    MuiIconButton: {
        disableFocusRipple: true,
        color: 'inherit',
    },
    MuiButtonGroup: {
        disableFocusRipple: true,
        disableRipple: true,
        disableElevation: true,
        variant: 'contained',
    },
    MuiSwitch: {
        color: 'default',
        disableRipple: true,
    },
};
theme.overrides = {
    MuiDialogActions: {
        root: {
            padding: theme.spacing(3, 4),
        },
    },
    MuiChip: {
        root: {
            fontSize: 14,
        },
    },
    MuiAppBar: {
        root: {
            zIndex: zIndex.sidebar,
        },
    },
    // Accordion
    MuiAccordionSummary: {
        root: {
            flexDirection: 'row-reverse',
            padding: theme.spacing(0, 3),
            '&$focused': {
                backgroundColor: '#DBF6F5',
            },
        },
    },
    MuiAccordionDetails: {
        root: {
            padding: theme.spacing(2, 3, 3),
            paddingLeft: 44,
        },
    },
    // Tooltip
    MuiTooltip: {
        tooltip: {
            backgroundColor: theme.palette.secondary.light,
        },
        arrow: {
            color: theme.palette.secondary.light,
        },
    },
    MuiButton: {
        root: {
            textTransform: 'none',
            borderRadius: borderRadius.s,
            color: colors.white,
            '&.Mui-disabled': {
                border: 'none',
                color: '#9B9B9B !important',
                backgroundColor: '#F5F5F5 !important',
            },
            '&.Mui-focusVisible': {
                boxShadow: '0 0 0 2px #4AD2CB !important',
            },
        },
        sizeSmall: __assign(__assign({}, typography.text.m), { padding: '10px 16px' }),
        sizeLarge: __assign(__assign({}, typography.text.xl), { padding: '14px 24px' }),
        text: {
            padding: '12px 24px',
            backgroundColor: 'transparent',
            color: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: '#DBF6F5',
            },
            '&:active': {
                backgroundColor: '#C3F0EE',
            },
        },
        textPrimary: {
            padding: '12px 24px',
            backgroundColor: 'transparent',
            color: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: '#DBF6F5',
            },
            '&:active': {
                backgroundColor: '#C3F0EE',
            },
        },
        contained: {
            padding: '12px 24px',
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: theme.palette.primary.light,
            },
            '&:active': {
                backgroundColor: theme.palette.primary.main,
            },
        },
        containedPrimary: {
            padding: '12px 24px',
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: theme.palette.primary.light,
            },
            '&:active': {
                backgroundColor: theme.palette.primary.main,
            },
        },
        containedSecondary: {
            backgroundColor: '#FFFFFF1A',
            '&:hover': {
                backgroundColor: '#FFFFFF33',
            },
            '&:active': {
                backgroundColor: '#FFFFFF4D',
            },
        },
        outlined: {
            padding: '12px 24px',
            color: theme.palette.primary.main,
            border: "1px solid " + theme.palette.primary.main,
            '&:hover': {
                borderColor: theme.palette.primary.light,
                backgroundColor: 'transparent',
            },
            '&:active': {
                borderColor: theme.palette.primary.main,
                backgroundColor: 'transparent',
            },
            '&.Mui-disabled': {
                border: 'none',
            },
        },
        outlinedPrimary: {
            padding: '12px 24px',
            color: theme.palette.primary.main,
            border: "1px solid " + theme.palette.primary.main,
            '&:hover': {
                borderColor: theme.palette.primary.light,
                backgroundColor: 'transparent',
            },
            '&:active': {
                borderColor: theme.palette.primary.main,
                backgroundColor: 'transparent',
            },
            '&.Mui-disabled': {
                border: 'none',
            },
        },
    },
    MuiIconButton: {
        root: {
            '&.Mui-focusVisible': {
                boxShadow: '0 0 0 2px #4AD2CB',
            },
        },
    },
    MuiButtonGroup: {
        groupedContainedSecondary: {
            '&:not(:last-child)': {
                borderColor: '#bdbdbd',
            },
        },
    },
    MuiLink: {
        root: {
            color: colors.neon,
            cursor: 'pointer',
            '&:hover': {
                color: theme.palette.primary.light,
            },
            '&:active': {
                color: theme.palette.primary.dark,
            },
        },
    },
    MuiContainer: {
        root: (_a = {
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3)
            },
            _a[theme.breakpoints.up('sm')] = {
                paddingLeft: theme.spacing(5),
                paddingRight: theme.spacing(5),
            },
            _a),
    },
    MuiBadge: {
        colorPrimary: {
            backgroundColor: colors.neon,
        },
        colorSecondary: {
            backgroundColor: colors.gray,
        },
        colorError: {
            backgroundColor: colors.red600,
        },
        badge: {
            color: theme.palette.common.white,
            height: 16,
            lineHeight: 1.1,
            fontSize: typography.text.xs.fontSize,
            fontWeight: theme.typography.fontWeightRegular,
            borderRadius: 8,
            minWidth: 21,
        },
    },
    MuiFormControl: {
        root: {
            '& .MuiSlider-root': {
                width: 'auto',
                position: 'absolute',
                left: 0,
                right: 0,
                top: '100%',
                transform: 'translateY(-100%)',
                zIndex: 5,
            },
        },
    },
    MuiInput: {
        formControl: {
            'label + &': {
                marginTop: 0,
            },
        },
        underline: {
            '&:hover:not($disabled):before': {
                borderBottom: "1px solid " + theme.palette.grey[400],
            },
            '&:before': {
                borderBottomColor: theme.palette.grey[200],
            },
            '&$disabled:before': {
                borderBottomStyle: 'dashed',
            },
        },
    },
    MuiInputBase: {
        root: {
            fontSize: typography.text.xl.fontSize,
            lineHeight: '28px',
        },
        input: {
            height: 28,
            padding: '28px 0 8px 0',
            transition: 'background 0.2s ease',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
        },
        inputMarginDense: {
            fontSize: typography.text.m.fontSize,
            lineHeight: '20px',
            paddingTop: 14,
            paddingBottom: 6,
        },
        multiline: {
            padding: '28px 0 0 0',
            '&$marginDense': {
                paddingTop: 14,
                '& $inputMultiline': {
                    paddingTop: 8,
                    paddingBottom: 6,
                },
            },
        },
        inputMultiline: {
            whiteSpace: 'normal',
            overflow: 'auto',
            paddingBottom: 8,
            '&[data-resize=vertical]': {
                resize: 'vertical',
            },
            '&[data-resize=horizontal]': {
                resize: 'horizontal',
            },
        },
    },
    MuiOutlinedInput: {
        root: {
            background: colors.gray50,
            '&:hover $notchedOutline': {
                borderColor: colors.gray450,
            },
            '&$focused $notchedOutline': {
                borderColor: colors.neon,
            },
            '&$error $notchedOutline': {
                borderColor: colors.error,
            },
            '&$error': {
                '&$focused .MuiOutlinedInput-input': {
                    background: colors.red50,
                },
            },
            '&$disabled $notchedOutline': {
                borderColor: colors.gray250,
            },
            '& ~ .MuiSlider-root': {
                left: 24,
                right: 24,
            },
        },
        marginDense: {
            '& ~ .MuiSlider-root': {
                left: 16,
                right: 16,
            },
        },
        input: {
            padding: '28px 24px 8px 24px',
        },
        notchedOutline: {
            top: 0,
            padding: 0,
            '& legend': {
                display: 'none',
            },
        },
        inputMarginDense: {
            fontSize: typography.text.m.fontSize,
            paddingLeft: 16,
            paddingRight: 16,
            paddingTop: 14,
            paddingBottom: 6,
        },
        adornedEnd: {
            paddingRight: 24,
            '&$marginDense': {
                paddingRight: 16,
            },
        },
        adornedStart: {
            paddingLeft: 24,
            '&$marginDense': {
                paddingLeft: 16,
            },
        },
        multiline: {
            padding: '28px 0 0 24px',
            '&$marginDense': {
                paddingTop: 22,
                paddingLeft: 16,
                paddingBottom: 0,
                '& $inputMultiline': {
                    paddingTop: 0,
                    paddingRight: 16,
                },
            },
        },
        inputMultiline: {
            paddingRight: 24,
            paddingBottom: 8,
        },
    },
    MuiInputLabel: {
        marginDense: {
            fontSize: typography.text.m.fontSize,
            transform: 'translate(0, 26px) scale(1)',
        },
        outlined: {
            transform: 'translate(24px, 23px) scale(1)',
            '&$shrink': {
                transform: "translate(24px, 10px) scale(0.75)",
                '&$marginDense': {
                    transform: 'translate(16px, 6px) scale(0.75)',
                },
            },
            '&$marginDense': {
                fontSize: typography.text.m.fontSize,
                transform: 'translate(16px, 18px) scale(1)',
            },
        },
    },
    MuiFormHelperText: {
        root: {
            fontSize: typography.text.s.fontSize,
            '&$marginDense': {
                fontSize: typography.text.xxs.fontSize,
            },
        },
        contained: {
            marginLeft: 24,
            marginRight: 24,
            '&$marginDense': {
                marginLeft: 16,
                marginRight: 16,
            },
        },
    },
    MuiFormLabel: {
        root: {
            fontSize: typography.text.xl.fontSize,
        },
    },
    MuiSelect: {
        icon: {
            top: 'calc(50% - 8px)',
            color: theme.palette.secondary.main,
        },
        selectMenu: {
            minHeight: 28,
            lineHeight: '28px',
        },
        select: {
            '&:focus': {
                backgroundColor: 'transparent',
            },
            '&[multiple]': {
                marginTop: 22,
                paddingTop: 0,
            },
            '& > option': {
                paddingLeft: 0,
                paddingRight: 0,
            },
            '&$outlined': {
                '&[multiple]': {
                    marginTop: 30,
                },
            },
        },
    },
    MuiSlider: {
        root: {
            background: 'none',
            width: '100%',
            height: 2,
            paddingTop: 0,
            paddingBottom: 0,
            marginBottom: 16,
            display: 'block',
            '&$vertical': {
                width: 2,
                height: 300,
            },
            lineHeight: 0,
        },
        rail: {
            backgroundColor: colors.gray250,
            opacity: 1,
        },
        track: {
            height: 2,
            borderRadius: 4,
            backgroundColor: colors.neon,
        },
        thumb: {
            backgroundColor: colors.neon,
            borderStyle: 'solid',
            borderColor: '#fff',
            borderWidth: 4,
            '&, &:focus, &:hover': {
                boxShadow: shadows.shadow01,
            },
            '&:focus, &:hover': {
                transform: 'scale(1.2)',
            },
            '&, &$disabled': {
                height: 22,
                width: 22,
                marginTop: -10,
                marginLeft: -12,
            },
            '&$disabled': {
                backgroundColor: colors.gray200,
            },
            '$vertical &': {
                marginLeft: -10,
            },
        },
        mark: {
            backgroundColor: colors.neon,
        },
        marked: {
            marginBottom: 32,
        },
        markLabel: {
            color: colors.gray600,
            textOverflow: 'ellipsis',
            top: 16,
            fontSize: typography.text.s.fontSize,
            lineHeight: typography.text.s.lineHeight,
        },
        valueLabel: {
            color: colors.neon,
            marginLeft: 2,
        },
    },
    MuiCheckbox: {
        root: {
            '&:hover, &$checked:hover': {
                backgroundColor: 'transparent !important',
            },
            '&:hover': {
                '& .CheckBoxIcon': {
                    borderColor: theme.palette.grey[400],
                },
            },
            '&$checked:hover': {
                '& .CheckBoxIcon': {
                    borderColor: 'transparent',
                },
            },
            '&.Mui-focusVisible': {
                boxShadow: 'none',
                '& .CheckBoxIcon': {
                    borderColor: 'transparent',
                    '&:after': {
                        boxShadow: "inset " + shadows.shadow02,
                    },
                },
            },
        },
    },
    MuiRadio: {
        root: {
            '&:hover, &$checked:hover': {
                backgroundColor: 'transparent !important',
            },
            '&:hover': {
                '& .RadioIcon': {
                    borderColor: theme.palette.grey[400],
                },
            },
            '&$checked:hover': {
                '& .RadioIcon': {
                    borderColor: 'transparent',
                },
            },
            '&.Mui-focusVisible': {
                boxShadow: 'none',
                '& .RadioIcon': {
                    borderColor: 'transparent',
                    '&:before': {
                        boxShadow: "inset " + shadows.shadow02,
                    },
                },
            },
        },
    },
    MuiSwitch: {
        root: {
            width: 38,
            height: 22,
            padding: 3,
            '&-colorDefault': {
                '& $switchBase': {
                    '&$checked': {
                        '&:not($disabled) + $track': {
                            opacity: 1,
                            backgroundColor: theme.palette.primary.main,
                        },
                    },
                    '&:not($disabled) + $track': {
                        backgroundColor: colors.gray350,
                    },
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                    '&.Mui-focusVisible': {
                        '& $thumb': {
                            boxShadow: shadows.shadow02,
                        },
                    },
                },
            },
        },
        switchBase: {
            padding: 3,
            top: 1,
            left: 1,
            '&$checked': {
                transform: 'translateX(16px)',
            },
            '& svg': {
                fontSize: 14,
            },
        },
        thumb: {
            width: 14,
            height: 14,
            boxShadow: 'none',
        },
        track: {
            borderRadius: 32,
            opacity: 1,
        },
        sizeSmall: {
            width: 32,
            height: 20,
            padding: 3,
            '& $thumb': {
                width: 12,
                height: 12,
            },
            '& $switchBase': {
                padding: 3,
                '&$checked': {
                    transform: 'translateX(12px)',
                },
                '& svg': {
                    fontSize: 12,
                },
            },
        },
    },
    MuiTypography: {
        h1: (_b = {},
            _b[theme.breakpoints.down('sm')] = __assign({}, typography.headings.m),
            _b),
        h2: (_c = {},
            _c[theme.breakpoints.down('sm')] = __assign({}, typography.headings.s),
            _c),
        h3: (_d = {},
            _d[theme.breakpoints.down('sm')] = __assign({}, typography.headings.xs),
            _d),
        h4: (_e = {},
            _e[theme.breakpoints.down('sm')] = __assign({}, typography.headings.xxs),
            _e),
        h5: (_f = {},
            _f[theme.breakpoints.down('sm')] = __assign({}, typography.headings.xxs),
            _f),
        h6: (_g = {},
            _g[theme.breakpoints.down('sm')] = __assign({}, typography.headings.xxs),
            _g),
        body1: (_h = {},
            _h[theme.breakpoints.down('sm')] = __assign({}, typography.text.l),
            _h),
        body2: (_j = {},
            _j[theme.breakpoints.down('sm')] = __assign({}, typography.text.m),
            _j),
        caption: (_k = {},
            _k[theme.breakpoints.down('sm')] = __assign({}, typography.text.s),
            _k),
        gutterBottom: (_l = {},
            _l[theme.breakpoints.down('sm')] = {
                marginBottom: theme.spacing(3),
            },
            _l.marginBottom = theme.spacing(4),
            _l),
        colorPrimary: {
            color: theme.palette.text.primary,
        },
        colorSecondary: {
            color: theme.palette.common.white,
        },
        colorError: {
            color: theme.palette.error.main,
        },
        colorTextPrimary: {
            color: theme.palette.text.primary,
        },
        colorTextSecondary: {
            color: theme.palette.text.secondary,
        },
        subtitle1: __assign(__assign({ color: colors.neon }, typography.text.l), { fontWeight: fontWeight.medium, lineHeight: typography.text.m.lineHeight }),
        subtitle2: __assign({}, typography.text.xs),
    },
    MuiPaper: {
        rounded: {
            borderRadius: 8,
        },
        elevation1: {
            boxShadow: shadows.shadow04,
        },
        elevation2: {
            boxShadow: shadows.shadow08,
        },
        elevation3: {
            boxShadow: shadows.shadow08,
            border: borderWidth.s + " solid " + theme.palette.divider,
        },
    },
    MuiInputAdornment: {
        root: {
            '& .MuiButtonBase-root': {
                zIndex: 1,
                '&:hover, &:active, &:focus': {
                    backgroundColor: 'unset',
                },
            },
        },
    },
    // Breadcrumbs
    MuiBreadcrumbs: {
        separator: {
            margin: theme.spacing(0, 2),
        },
    },
    // Tabs
    MuiTabs: {
        root: {
            minHeight: 40,
            overflow: 'visible',
            borderBottom: "2px solid " + theme.palette.divider,
        },
        scroller: {
            overflow: 'visible !important',
        },
        indicator: {
            bottom: -2,
        },
    },
    MuiTab: {
        root: {
            minWidth: 'auto !important',
            opacity: 1,
            padding: '8px 16px',
            textTransform: 'none',
            '&:focus-visible': {
                backgroundColor: '#DBF6F5',
            },
        },
        wrapper: {
            flexDirection: 'row',
            '& > svg': {
                marginBottom: 0,
                marginRight: 12,
            },
            '& > *:first-child': {
                marginBottom: '0 !important',
            },
        },
        labelIcon: {
            minHeight: 48,
        },
    },
    // Table
    MuiTableBody: {
        root: {
            '& [class*="MuiTableRow-root"]': {
                '&:last-child': {
                    '& [class*="MuiTableCell-root"]': {
                        border: 'none',
                    },
                },
            },
        },
    },
    MuiTableCell: {
        root: {
            padding: '10px 16px',
            minHeight: 56,
            borderBottomColor: theme.palette.grey[100],
        },
        head: __assign(__assign({}, typography.text.xxs), { padding: '16px 16px 4px', textTransform: 'uppercase', fontWeight: 400, color: theme.palette.grey[600], lineHeight: '16px' }),
        body: __assign(__assign({}, typography.text.m), { color: theme.palette.secondary.main }),
    },
    // @ts-ignore
    // Autocomplete
    MuiAutocomplete: {
        inputRoot: {
            '&[class*="MuiOutlinedInput-root"]': {
                padding: '28px 24px 8px 24px',
                '& $input': {
                    padding: 0,
                    '&:first-child': {
                        padding: 0,
                    },
                },
                '&[class*="MuiOutlinedInput-marginDense"]': {
                    padding: '14px 16px 6px',
                },
            },
            '&[class*="MuiInput-root"]': {
                paddingTop: 24,
                paddingBottom: 0,
                '&[class*="MuiInputBase-marginDense"]': {
                    paddingTop: 14,
                    paddingBottom: 0,
                },
            },
        },
        paper: {
            border: borderWidth.s + " solid " + colors.gray250,
            borderRadius: borderRadius.s + "px",
            boxShadow: shadows.shadow08,
        },
        tag: {
            margin: '4px 4px 4px 0',
        },
        endAdornment: {
            top: 'calc(50% - 12px)',
            display: 'flex',
            '& $popupIndicator': {
                padding: 4,
            },
        },
    },
    // Calendar
    MuiPickersPopper: {
        root: {
            '&[x-placement="top"]': {
                '& $paper': {
                    bottom: 12,
                },
            },
            '&[x-placement="bottom"]': {
                '& $paper': {
                    top: 12,
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: '-8px',
                        left: 'calc(50% - 13px)',
                        width: 0,
                        borderBottom: "13px solid " + theme.palette.secondary.light,
                        borderLeft: '13px solid transparent',
                        borderRight: '13px solid transparent',
                    },
                },
            },
        },
        paper: {
            boxShadow: shadows.shadow04,
            borderRadius: 8,
            position: 'relative',
        },
    },
    MuiPickersBasePicker: {
        pickerView: {
            maxHeight: 364,
            backgroundColor: theme.palette.secondary.light,
            borderRadius: 8,
        },
    },
    MuiPickersDateRangePickerInput: {
        root: {
            '& > [class*="MuiFormControl-root"]:last-child': {
                marginLeft: '11px',
            },
        },
    },
    MuiPickersDesktopDateRangeCalendar: {
        rangeCalendarContainer: {
            backgroundColor: theme.palette.secondary.light,
            boxShadow: shadows.shadow04,
            position: 'relative',
            '&:not(:last-child)': {
                borderRadius: "8px 0 0 8px",
                borderRight: 'none',
                '& $calendar': {
                    borderRadius: "0 0 0 8px",
                },
            },
            '&:last-child': {
                borderRadius: "0 8px 8px 0",
                '& $calendar': {
                    borderRadius: "0 0 8px 0",
                },
            },
        },
        arrowSwitcher: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1),
            '& [class*="MuiTypography-root"]': {
                color: theme.palette.primary.main,
            },
        },
    },
    MuiPickersCalendarHeader: {
        root: {
            marginTop: '20px',
            marginBottom: theme.spacing(2),
        },
        monthText: __assign(__assign({ color: theme.palette.primary.main, textTransform: 'capitalize' }, typography.text.l), { fontWeight: fontWeight.medium }),
        monthTitleContainer: {
            '& [class*="MuiPickersFadeTransition-root"]': {
                display: 'flex',
                alignItems: 'center',
            },
        },
        yearSelectionSwitcher: {
            color: theme.palette.primary.main,
        },
    },
    MuiPickersCalendar: {
        root: {
            minHeight: '270px',
            backgroundColor: colors.gray0,
            borderRadius: "8px 8px 0 0",
        },
        week: {
            margin: theme.spacing(1, 0),
        },
        weekDayLabel: __assign({ margin: theme.spacing(0, 1), height: '34px', color: colors.gray0 }, typography.text.xs),
        weekContainer: {
            '& > div[class*="MuiPickersCalendar-week"]:first-child': {
                margin: '16px 0 2px 0',
            },
        },
    },
    MuiPickersDateRangeDay: {
        rangeIntervalDayHighlight: {
            backgroundColor: 'rgba(0, 178, 169, 0.05)',
            borderTop: borderWidth.s + " solid rgba(0, 178, 169, 0.0953344)",
            borderBottom: borderWidth.s + " solid rgba(0, 178, 169, 0.0953344)",
            '&:last-child, &End': {
                borderRight: borderWidth.s + " solid rgba(0, 178, 169, 0.0953344)",
            },
            '&:first-child, &Start': {
                borderLeft: borderWidth.s + " solid rgba(0, 178, 169, 0.0953344)",
            },
        },
        dayInsideRangeInterval: {
            color: theme.palette.secondary.main,
            '&[class*="MuiPickersDay-dayOutsideMonth"]': {
                color: colors.gray350,
            },
        },
        dayOutsideRangeInterval: {
            '&:hover': {
                border: 'none',
            },
        },
    },
    MuiPickersDay: {
        root: __assign(__assign({ color: theme.palette.secondary.main }, typography.text.l), { '&:hover, &:active, &:focus': {
                backgroundColor: 'unset',
            }, '&$disabled': {
                color: colors.gray350,
            }, '&$selected': {
                backgroundColor: theme.palette.primary.main,
                borderRadius: 8,
                '&:hover, &:active, &:focus': {
                    willChange: 'unset',
                    backgroundColor: theme.palette.primary.main,
                },
            }, '&:focus.Mui-selected[class*="MuiButtonBase-root"]': {
                backgroundColor: theme.palette.primary.main,
            } }),
        today: {
            color: theme.palette.primary.main,
            '&:not(Mui-selected)[class*="MuiPickersDay-root"]': {
                border: 'none',
            },
        },
        dayOutsideMonth: {
            color: colors.gray350,
        },
        dayWithMargin: {
            margin: theme.spacing(0, 1),
        },
    },
    MuiPickersArrowSwitcher: {
        iconButton: {
            backgroundColor: 'unset',
        },
    },
    MuiPickersYear: {
        yearButton: {
            color: theme.palette.primary.main,
            fontWeight: fontWeight.medium,
        },
    },
    // Pagination
    MuiPaginationItem: {
        page: {
            '&$selected': {
                '&:hover': {
                    backgroundColor: colors.neon150,
                },
                '&:active': {
                    backgroundColor: colors.neon200,
                },
            },
        },
    },
    // Skeleton
    MuiSkeleton: {
        root: {
            backgroundColor: colors.gray200,
        },
    },
};
export default theme;
//# sourceMappingURL=base.js.map